/*
 * -----------------------------------------------------------------------
 *  <copyright file="existing-user-invitation.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import Settings from '../../../settings/settings';
import Button from '../../components/core/buttons/button';
import Loading from '../../components/core/loading';
import { UserContext } from '@contexts/user-context';
import { useBoolean, useTranslation } from '@hooks/index';
import { AllRoutes } from '@utils/router/all-routes';

const ExistingUserInvitation = ({ id, member, name }: { id: string; member: any; name: string }) => {
    const loading = useBoolean(false);
    const { t } = useTranslation();
    const [error, setError] = useState();
    const { setToken } = useContext(UserContext);
    const navigate = useNavigate();

    const acceptInvite = () => {
        setError(null);
        loading.setTrue();

        fetch(`${Settings.api.url()}/api/accept-organisation-invite`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id,
                memberId: member.id,
                organisationKey: member.organisationKey,
            }),
        })
            .then((response) => {
                loading.setFalse();

                return response.json();
            })
            .then((token) => {
                // Set token
                if (token && token.token) {
                    setToken(token.token);
                    navigate(AllRoutes.path('home'));
                }
            })
            .catch((e) => setError(e.message));
    };

    return (
        <>
            <br />
            <h3>
                {t('uam:createExistingOrganisationUser')}: {name}
            </h3>
            <br />
            <br />
            <Button onClick={acceptInvite} disabled={loading.value} secondary fullWidth>
                {t('uam:acceptInvitation')}
            </Button>
            {loading.value && <Loading />}
            <div style={{ display: error ? 'block' : 'none' }}>{error}</div>
        </>
    );
};

export default ExistingUserInvitation;
